<template>
    <div class="floating-chat-btn" v-if="website.facebook">
        <a :href="`https://www.messenger.com/t/${website.facebook}`" class="btn-floating" target="_blank">
            <i class="fa-brands fa-facebook-messenger"></i>
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            website: {
                Type: Object,
                data() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },
        mounted() {},
        methods: {}
    }
</script>

<style scoped>
    .floating-chat-btn {
        position: fixed;
        bottom: 70px;
        right: 20px;
    }

    a.btn-floating {
        background: rgb(125, 155, 245);
        display: block;
        color: #fff;
        text-align: center;
        padding: 20px 23px;
        border-radius: 50%;
        animation: pulse 2s infinite;
    }

    .btn-floating i {
        font-size: 25pt;
        margin: auto;
        animation: shake-icon 1s infinite ease-in-out;
    }

    @keyframes pulse {
        0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
        }

        70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
        }

        100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
    }

    @keyframes shake-icon {
        0% {
            transform: rotate(0) scale(1) skew(1deg);
        }

        10% {
            transform: rotate(-25deg) scale(1) skew(1deg);
        }

        20% {
            transform: rotate(25deg) scale(1) skew(1deg);
        }

        30% {
            transform: rotate(-25deg) scale(1) skew(1deg);
        }

        40% {
            transform: rotate(25deg) scale(1) skew(1deg);
        }

        50% {
            transform: rotate(0) scale(1) skew(1deg);
        }

        100% {
            transform: rotate(0) scale(1) skew(1deg);
        }
    }
</style>
